import { Component, Inject, forwardRef, Host } from '@angular/core';

import { AwesomeDataTable } from './../table/table.component';

@Component({
  selector: 'adata-table-header',
  template: `<div class="adata-table-header clearfix">
    <h5 class="title" [textContent]="adataTable.headerTitle"></h5>
    <div class="button-panel">
        <a class="btn btn-flat btn-flat-icon" href="javascript:"
            (click)="adataTable.reloadItems()"
            *ngIf="adataTable.showReloadButton">
            <i class="fa fa-refresh"></i>
        </a>
        <a class="btn btn-flat btn-flat-icon" href="javascript:"
            (click)="adataTable.downloadItems()"
            *ngIf="adataTable.showDownloadButton">
            <i class="fa fa-download"></i>
        </a>
        <a class="btn btn-flat btn-flat-icon" href="javascript:" 
            [class.active]="columnSelectorOpen"
            (click)="settingsClick($event)"
            *ngIf="adataTable.showColumnSelectorButton">
            <i class="fa fa-cog"></i>
        </a>
        <div class="column-selector-wrapper dropdown" (click)="$event.stopPropagation()">
            <div *ngIf="columnSelectorOpen" class="dropdown-menu dropdown-menu-right show">
                <h6 class="dropdown-header" [textContent]="adataTable.translations.columnsMenuHeaderText"></h6>
                <div class="adata-dropdown-item">
                    <div *ngIf="adataTable.expandableRows">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" [(ngModel)]="adataTable.expandColumnVisible" class="custom-control-input"/>
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{adataTable.translations.expandColumn}}</span>
                        </label>
                    </div>
                    <div *ngIf="adataTable.indexColumn">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" [(ngModel)]="adataTable.indexColumnVisible" class="custom-control-input"/>
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{adataTable.translations.indexColumn}}</span>
                        </label>
                    </div>
                    <div *ngIf="adataTable.selectColumn">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" [(ngModel)]="adataTable.selectColumnVisible" class="custom-control-input"/>
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description">{{adataTable.translations.selectColumn}}</span>
                        </label>
                    </div>
                    <div *ngFor="let column of adataTable.columns">
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" [(ngModel)]="column.visible" class="custom-control-input"/>
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description" [textContent]="column.header"></span>
                        </label>
                    </div>
                </div>
                <h6 class="dropdown-header" [textContent]="adataTable.translations.rowsMenuHeaderText"></h6>
                <div class="adata-dropdown-item">
                    <select class="custom-select" [(ngModel)]="adataTable.limit" (ngModelChange)="onLimitValueChange($event)">
                        <option *ngFor="let row of adataTable.getRowsLimitList()" [value]="row">{{row}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.adata-table-header{min-height:25px;margin-bottom:10px}.adata-table-header .title{margin:20px 0 0 20px;float:left}.adata-table-header .button-panel{float:right;margin:15px 15px 0 0}.adata-table-header .adata-dropdown-item{padding:0 15px}.adata-table-header .adata-dropdown-item label{display:block;line-height:1.5}.adata-table-header .column-selector-wrapper .dropdown-menu{position:absolute;left:calc(100% - 200px);min-width:200px}.adata-table-header .btn{outline:0!important;border-radius:2px;font-size:.95rem;font-family:inherit;line-height:1.25}.adata-table-header .btn-flat{border-color:transparent!important;border-radius:2px;background-color:transparent;text-transform:uppercase}.adata-table-header .btn-flat.active,.adata-table-header .btn-flat:active{-webkit-box-shadow:0 0 0 #000;box-shadow:0 0 0 #000}.adata-table-header .btn-flat.text-white{color:#fff!important}.adata-table-header .btn-flat.disabled,.adata-table-header .btn-flat[disabled]{background-color:transparent!important}.adata-table-header .btn-flat.btn-flat-icon{border-radius:50%;font-size:24px;height:32px;width:32px;padding:0;overflow:hidden;color:inherit!important}.adata-table-header .btn-flat.btn-flat-icon>em{line-height:32px}.adata-table-header .btn-flat.btn-flat-icon:active,.adata-table-header .btn-flat.btn-flat-icon:focus,.adata-table-header .btn-flat.btn-flat-icon:hover{background-color:rgba(158,158,158,.2)!important}`]
})
export class AwesomeDataTableHeader {
    columnSelectorOpen = false;

    @Host() _closeSelector() {
        this.columnSelectorOpen = false;
    }

    constructor(@Inject(forwardRef(() => AwesomeDataTable)) public adataTable: AwesomeDataTable) {}

    settingsClick($event) {
        $event.stopPropagation();
        const self = this;
        if (this.columnSelectorOpen) {
            this.columnSelectorOpen = false;
        } else {
            this.columnSelectorOpen = true;
            document.body.onclick = () => {
                self.columnSelectorOpen = false;
                document.body.onclick = null;
            };
        }
    }

    onLimitValueChange($event) {
        this.columnSelectorOpen = false;
        document.body.onclick = null;
        this.adataTable.page = 1;
    }
}
